<template>
  <div class="row">
    <header-servico
      tipo="Medida Socioeducativa"
      :loading="loading"
      :familia="familia.id"
      page="medidas"
    />
    <load
      v-if="loading"
      message="Carregando a Medida Socioeducativa da Família"
    />
    <div v-else class="col-md-12">
      <!--Tabela-->
      <div class="row">
        <SidebarServico :item="medida" @page="showPage" />
        <ModalVerificarPrivado
          :familia-id="familia.id"
          v-if="medida.privado == 1 && status_privado == false"
          @liberar="status_privado = true"
        />
        <div
          class="col-md-9"
          v-else
          v-on:mousemove="status_privado = !checkInactivity"
        >
          <div class="row">
            <div class="col-md-12">
              <header-familia :item="familia" />
            </div>
          </div>
          <div v-if="page == 'medidas'">
            <div v-if="historicoStatus == false" class="card mb-0 shadow">
              <div class="card-body">
                <div class="tab-content">
                  <div class="animate__animated animate__fadeIn">
                    <div class="col-12 px-0">
                      <h4 class="font-weight-bold">
                        Gestão da Medida Socioeducativa
                      </h4>
                    </div>
                    <HeaderMedida class="px-0" :medida="medida" />
                    <b-tabs content-class="mt-3">
                      <b-tab title="Detalhes" active>
                        <div class="row">
                          <form-select
                            v-model="medida.tipo_id"
                            label="Tipo"
                            :required="true"
                            :itens="tipos"
                            :loading="loadingSelects"
                          />
                          <form-calendar
                            v-model="medida.processo_data_inicial"
                            grid="4"
                            label="Data de início"
                            :required="true"
                          />
                          <form-calendar
                            v-model="medida.processo_data_final"
                            grid="4"
                            label="Data Final"
                          />
                          <form-input
                            v-model="medida.numero_processo"
                            grid="4"
                            label="Número do Processo"
                          />
                          <form-select
                            v-model="medida.unidade_id_referencia"
                            label="Unidade  de Referência"
                            :itens="unidades_all"
                            grid="4"
                            :loading="loadingSelects"
                            @selected="searchTecnicosAll"
                          />
                          <form-select
                            v-model="medida.tecnico_referencia"
                            label="Técnico de Referência"
                            :itens="tecnicos_all"
                            grid="4"
                            :loading="loadingTecnicosAll"
                          />
                          <form-select
                            v-model="medida.orientador_referencia"
                            label="Orientador de Referência"
                            :itens="tecnicos_all"
                            grid="4"
                            :loading="loadingTecnicos"
                          />
                          <form-toggle
                            class="d-flex justify-content-start"
                            mt="0"
                            v-model="medida.acomp_creas"
                            label="Acompanhamento Anterior da Medida"
                          />
                          <form-select
                            v-if="medida.acomp_creas"
                            v-model="medida.acomp_creas_unidade_id"
                            label="Unidade"
                            :itens="unidades_all"
                            grid="6"
                            :loading="loadingSelects"
                            @selected="searchTecnicos"
                          />

                          <form-input
                            grid="6"
                            v-if="medida.acomp_creas"
                            label="Outra Unidade"
                            v-model="medida.acomp_outra_unidade"
                          />
                          <!-- <form-select
                                                        v-if="
                                                            medida.acomp_creas
                                                        "
                                                        v-model="
                                                            medida.orientador_social
                                                        "
                                                        label="Orientador Social"
                                                        :itens="tecnicos"
                                                        grid="6"
                                                        :loading="
                                                            loadingTecnicos
                                                        "
                                                    /> -->
                          <form-calendar
                            v-if="medida.acomp_creas"
                            v-model="medida.acomp_data_inicial"
                            grid="6"
                            label="Data de início"
                          />
                          <form-calendar
                            v-if="medida.acomp_creas"
                            v-model="medida.acomp_data_final"
                            grid="6"
                            label="Data final"
                          />
                          <form-select
                            v-model="medida.execucao"
                            label="Forma de Execução"
                            :itens="$root.arrays.forma_execucao"
                            grid="6"
                          />
                          <form-input
                            v-model="medida.instituicao_prisional"
                            grid="6"
                            label="Unidade Socioeducativa"
                          />
                          <form-input
                            v-model="medida.tempo_pena"
                            grid="3"
                            label="Tempo da Medida"
                          />
                          <form-select
                            v-model="medida.periodo_pena"
                            label="Período da Medida"
                            :itens="$root.arrays.periodo"
                            grid="3"
                          />
                          <form-input
                            v-model="medida.intituicao_prisiona_cidade"
                            grid="6"
                            label="Cidade da Unidade Socioeducativa"
                          />
                          <form-textarea-editor
                            v-model="medida.observacoes_medida"
                            label="Observação sobre o cumprimento da medida"
                            :required="true"
                          />
                        </div>
                        <search-tecnico :tecnicos.sync="medida.tecnicos" />
                        <div class="row">
                          <form-select
                            @change="verificarStatus"
                            v-model="medida.status"
                            label="Status"
                            :itens="status"
                            grid="3"
                            :ajuda="ajuda_status"
                          />
                          <form-file
                            grid="9"
                            @submit="submitFile"
                            multiple
                            btn-text="Iniciar"
                            :progress="progressCompleted"
                          />
                        </div>
                        <div class="row px-0 d-flex justify-content-between">
                          <div>
                            <form-toggle
                              grid="12"
                              class="d-flex justify-content-end"
                              mt="0"
                              v-model="medida.privado"
                              label="Sigilo?"
                            />
                          </div>
                          <div class="col-auto text-right">
                            <a
                              class="router-link-exact-active active px-3"
                              @click="historicoStatus = true"
                            >
                              <i class="fas fa-history"></i>
                              Histórico de Status
                            </a>
                            <a
                              class="btn btn-primary"
                              @click="$bvModal.show('modal-auditoria')"
                              :title="$t('Auditoria')"
                              v-b-tooltip.hover
                            >
                              <i class="mdi mdi-timeline-clock-outline mdi-16px" />
                            </a>
                            <a
                              v-if="
                              $store.state.user.role_details.name == 'Admin' ||
                              $store.state.user.role_details.name == 'Gestor(a)' ||
                              $store.state.user.id == medida.user_id
                              "
                              title="Remanejar"
                              class="btn btn-warning py-2"
                              @click="$bvModal.show('modal-remanejar-servico')"
                            >
                              <i class="fas fa-exchange-alt mdi-18px" />
                              {{ $t("Remanejar") }}
                            </a>
                            <b-button
                              :title="$t('Visualizar e Imprimir')"
                              :to="'/dashboard/medida/show/' + medida.id"
                              class="py-1"
                              size="sm"
                              type="button"
                              v-b-tooltip.hover
                              variant="primary"
                            >
                              <i class="mdi mdi-printer mdi-18px" />
                            </b-button>
                            <button
                              class="btn btn-success btn-submit"
                              data-style="zoom-in"
                              type="submit"
                              @click="submit"
                            >
                              <i class="mdi mdi-content-save" />
                              {{ $t("Salvar") }}
                            </button>
                          </div>
                        </div>
                        <anexos :anexos="medida.anexos" />
                      </b-tab>
                      <b-tab title="Ato Infracional e Identificação Processual">
                        <Ato :medida="medida" @submit="submit" />
                      </b-tab>
                      <b-tab title="Profissionalização">
                        <Profissionalizacao :medida="medida" @submit="submit" />
                      </b-tab>
                      <b-tab title="Perspectiva de Vida">
                        <Pespectiva :medida="medida" @submit="submit" />
                      </b-tab>
                    </b-tabs>
                  </div>
                </div>
              </div>
            </div>
            <div class="card mb-0 shadow card-body" v-else>
              <div class="tab-content">
                <div class="animate__animated animate__fadeIn">
                  <div class="row">
                    <div class="col-12">
                      <h4 class="font-weight-bold">
                        Gestão da Medida Socioeducativa
                      </h4>
                    </div>
                    <HeaderMedida :medida="medida" />
                    <HistoricoStatus
                      @voltar="historicoStatus = false"
                      :id="medida.id"
                      :familia="medida.familia_id"
                      :status="status_medida"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Vunerabilidade
            :medida="medida"
            v-if="page == 'vunerabildiade'"
            @submit="submit"
          />
          <Avaliacao
            :medida="medida"
            v-if="page == 'avaliacao'"
            @submit="submit"
          />
          <Termo :medida="medida" v-if="page == 'termo'" @submit="submit" />
          <Meta :medida="medida" v-if="page == 'objetivo'" @submit="submit" />
          <Registro :medida="medida" v-if="page == 'aterior'" />
          <Mensal :medida="medida" v-if="page == 'mensal'" />
          <Pia :medida="medida" v-if="page == 'pia'" />
          <Auditoria :id="medida.id" v-if="page == 'historicopia'" />
        </div>
      </div>
    </div>
    <status-historico
      model="MedidasSocioeducativa"
      modulo="Medidas"
      titulo_modulo="MEDIDAS"
      :id="medida.id"
      :status-anterior="statusAnterior"
      :status-atual="statusAtual"
      :status="status_medida"
      @submit="submit"
    />
    <ModalRemanejarServico
      servico="medidas"
      :servico_id="medida.id"
      :tecnico_id="medida.responsavel.tecnico.id"
    />
    <ModalAuditoria
      servico="medidas"
      :servico_id="medida.id"
    />
  </div>
</template>
<script>
import ModalRemanejarServico from "../../../../../resources/js/dashboard/components/widgets/ModalRemanejarServico";
import SidebarServico from "./includes/SidebarServico";
import HeaderMedida from "./HeaderMedida";
import HistoricoStatus from "./HistoricoStatus";
import Vunerabilidade from "./includes/abas/Vunerabilidade";
import Avaliacao from "./includes/abas/Avaliacao";
import Auditoria from "./includes/abas/Auditoria";
import Termo from "./includes/abas/Termo";
import Mensal from "./includes/abas/Mensal";
import Meta from "./includes/abas/Meta";
import Pia from "./includes/abas/Pia";
import Ato from "./includes/abas/Ato";
import Registro from "./includes/abas/Registro";
import Pespectiva from "./includes/abas/Pespectiva";
import Profissionalizacao from "./includes/abas/Profissionalizacao";
import ModalVerificarPrivado from "./includes/ModalVerificarPrivado";
import ModalAuditoria from "../../../../../resources/js/dashboard/components/widgets/ModalAuditoria";
export default {
  components: {
    Auditoria,
    Ato,
    Mensal,
    Profissionalizacao,
    Pespectiva,
    Vunerabilidade,
    SidebarServico,
    HistoricoStatus,
    Avaliacao,
    HeaderMedida,
    Termo,
    Meta,
    Pia,
    Registro,
    ModalVerificarPrivado,
    ModalRemanejarServico,
    ModalAuditoria,
  },
  name: "Edit",
  data() {
    return {
      page: "medidas",
      statusAtual: "",
      statusAnterior: "",
      medida: { responsavel: { tecnico: {} } },
      tecnicos_all: {},
      tecnicos: {},
      unidades: {},
      unidades_all: {},
      tipos: {},
      servicos: {},
      familia: {},
      status_medida: {},
      files: {},
      loading: true,
      progressCompleted: 0,
      status_privado: false,
      loadingTecnicos: false,
      loadingTecnicosAll: false,
      historicoStatus: false,
      loadingSelects: true,
      loadingSelectsAll: true,
      status: {},
      inativo: false,
      model: "MedidasSocioeducativa",
      ajuda_status: `<b>ABERTO:</b> O status aberto é indicado quando o usuário da plataforma registra a Medida Socioeducativa, no caso esse status aponta que foi iniciado um registro, e posterior será possível o gerenciamento e indicação de outros status ( continuidade do acompanhamento da medida);<br><br>
            <b>EM ANDAMENTO:</b> O status Em Andamento é registrado sempre que o usuário da Plataforma gerencia o acompanhamento da Medida Socioeducativa de aberto para em andamento, como meio de registrar o período em que está vigente o acompanhamento;<br><br>
            <b>FINALIZADO:</b> O Status Finalizado é indicado sempre que o usuário da Plataforma,após gerenciar o acompanhamento da Medida Socioeducativa, atualiza o status para finalizado informando os motivos pelo qual está encerrando a intervenção. Os motivos podem ser: suspensão; pausa; não localizado, não adesão; mudança de cidade; óbito; cumprimento da medida.<br><br>
            <b>INATIVO:</b>O status inativo é atribuído a um registro quando não há mais necessidade de mantê-lo por várias razões. Normalmente, isso acontece devido à duplicação de informações ou à ausência de dados relevantes. Quando um registro é marcado como inativo, isso indica que ele não está mais em uso ativo e não será mais atualizado ou mantido.`,
    };
  },
  mounted() {
    this.getMedida();
  },
  computed: {
    checkInactivity() {
      if (this.$root.isIdle == true) {
        this.status_privado = false;
        this.$bvModal.show("verificar-medida-privado");
      }
      return this.$root.isIdle;
    },
  },
  methods: {
    showPage(page) {
      this.page = page;
    },
    // getAdolescentes() {
    //     axios
    //         .get(`api/dashboard/medidas/adolescentes/get`)
    //         .then((response) => {
    //             this.adolescentes = response.data;
    //         });
    // },
    // getTecnicos() {
    //     axios.get(`api/dashboard/tecnicos/get`).then((response) => {
    //         this.tecnicos = response.data;
    //     });
    // },
    searchTecnicos() {
      this.tecnicos = [];
      this.loadingTecnicos = true;
      axios
        .get(
          `api/dashboard/tecnicos/get/externos/${this.medida.acomp_creas_unidade_id}`
        )
        .then((response) => {
          this.tecnicos = response.data;
        })
        .finally(() => {
          this.loadingTecnicos = false;
          this.loadingSelects = false;
        });
    },
    searchTecnicosAll() {
      this.tecnicos_all = [];
      this.loadingTecnicosAll = true;
      axios
        .get(
          `api/dashboard/tecnicos/get/externos/${this.medida.unidade_id_referencia}`
        )
        .then((response) => {
          this.tecnicos_all = response.data;
        })
        .finally(() => {
          this.loadingTecnicosAll = false;
          this.loadingSelectsAll = false;
        });
    },
    // getTipos() {
    //     axios.get(`api/dashboard/tipos/medidas`).then((response) => {
    //         this.tipos = response.data;
    //     });
    // },
    // getUnidades() {
    //     axios
    //         .get(`api/dashboard/unidades/get/externas/medidas`)
    //         .then((response) => {
    //             this.unidades = response.data;
    //         });
    // },
    submitFile(files) {
      this.files = files;
      let formData = new FormData();
      if (this.files.length > 0 && this.files.length != undefined) {
        for (const i of Object.keys(this.files)) {
          formData.append("anexos[]", this.files[i]);
        }
      } else {
        formData.append("anexos", this.files);
      }
      formData.append("id", this.medida.id);
      formData.append("familia_id", this.medida.familia_id);
      this.loadAnexos = true;
      axios
        .post(`api/dashboard/upload/medida`, formData, {
          header: { "Content-Type": "multipart/form-data" },
          onUploadProgress: (event) => {
            let progress = Math.round((event.loaded * 100) / event.total);
            this.progressCompleted = progress;
          },
        })
        .then((response) => {
          this.medida.anexos = response.data;
          this.$snack.success({
            button: false,
            text: "Upload realizado com sucesso.",
          });
        })
        .finally(() => {
          this.progressCompleted = 0;
          this.files = [];
          this.loadAnexos = false;
        });
    },
    getCamposmedida(familia_id) {
      axios
        .get(`api/dashboard/medidas/get/campos/${familia_id}`)
        .then((response) => {
          this.adolescentes = response.data.adolescentes;
          this.tipos = response.data.tipos;
          this.status_medida = response.data.status_medida;
          this.status = response.data.status;
          this.unidades = response.data.unidades;
          this.unidades_all = response.data.unidades_all;
        });
    },
    getMedida() {
      this.loading = true;
      axios
        .get(`api/dashboard/medidas/${this.$route.params.id}`)
        .then((response) => {
          this.medida = response.data.data;
          this.statusAnterior = this.medida.status;
          this.familia = this.medida.familia_id;
          this.$route.query.familia_id = this.medida.familia_id.id;
          // this.getAdolescentes();
          // this.getTipos();
          // this.getStatusFinais();
          // this.getStatus();
          // this.getUnidades();
          this.getCamposmedida(this.familia.id);
          this.searchTecnicos();
          this.searchTecnicosAll();
        })
        .finally(() => {
          this.loading = false;
        })
        .catch((error) => {
          this.$router.push(
            `/dashboard/medidas/${this.$route.query.familia_id}`
          );
        });
    },
    verificarStatus(status) {
      this.statusAtual = status;
      const result = this.status_medida.filter((item) => item.id == status);
      //console.log(result);
      if (result[0].final == 1) {
        //compara os status finais com o status que foi alterado, caso seja igual será aberta a janela para salva o historico
        this.$bvModal.show(`status-historico-${this.model}`);
      }
    },
    // getStatusFinais() {
    //     axios
    //         .post(`api/dashboard/get/status/finais`, {
    //             model: "MedidasSocioeducativa",
    //             module: "Medidas",
    //         })
    //         .then((response) => {
    //             this.status_medida = response.data;
    //         });
    // },
    // getStatus() {
    //     axios.get(`api/dashboard/status/medidas`).then((response) => {
    //         this.status = response.data;
    //     });
    // },
    setTipos(tipos) {
      this.tipos = tipos;
    },
    submit() {
      this.medida.familia_id = this.familia.id;
      let ladda = Ladda.create(document.querySelector(".btn-submit"));
      if (ladda) {
        ladda.start();
      }
      axios
        .post(`api/dashboard/update/medida`, this.medida)
        .then((response) => {
          this.medida = response.data.data;
          ladda.stop();
          this.$snack.success({
            button: false,
            text: "Medida atualizado com sucesso.",
          });
        })
        .finally(() => {
          this.progressCompleted = 0;
          this.files = [];
        });
    },
    checkInactivityMoveMouse() {
      if (this.medida.privado == 1) {
        if (this.$root.isIdle == true) {
          this.status_privado = false;
          this.$bvModal.show("verificar-medida-privado");
        }
        return this.$root.isIdle;
      } else {
        return false;
      }
    },
  },
};
</script>
<style>
.router-link-exact-active {
  cursor: pointer;
}
</style>
